import React, { createContext, useContext, useEffect, useState } from "react";
import { useApi } from "../utils/Api";
import { ukToday } from "../utils/closedDates";

const StoreClosureContext = createContext();
export const useStoreClosure = () => useContext(StoreClosureContext);

export const StoreClosureProvider = ({ children }) => {
  const { apiFetch } = useApi();
  const [closures, setClosures] = useState([]);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const data = await apiFetch("get-store-closures");
        if (!cancelled) setClosures(Array.isArray(data) ? data : []);
      } catch {
        if (!cancelled) setClosures([]);
      }
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const today = ukToday();
  const todaysClosure = closures.find((c) => c.closed_date === today);
  const isClosed = Boolean(todaysClosure);
  const closedReason = todaysClosure?.reason || null;

  return (
    <StoreClosureContext.Provider value={{ isClosed, closedReason }}>
      {children}
    </StoreClosureContext.Provider>
  );
};
